import Logo from '@common/assets/svgs/Logo';
import { Box, Container, Typography, alpha, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  showLogo?: boolean;
}

const AuthLayout = ({ children, title, subtitle, showLogo = true }: AuthLayoutProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        minWidth: '100vw',
        display: 'flex',
        flexDirection: 'column',
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.03)} 0%, ${alpha(
          theme.palette.secondary.main,
          0.03
        )} 100%)`,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '50%',
          background: `linear-gradient(180deg, ${alpha(
            theme.palette.primary.main,
            0.05
          )} 0%, transparent 100%)`,
          zIndex: 0,
        },
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          py: { xs: 4, md: 6 },
          position: 'relative',
          zIndex: 1,
        }}
      >
        {(showLogo || title || subtitle) && (
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            {showLogo && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: 3,
                  filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.08))',
                }}
              >
                <Logo />
              </Box>
            )}
            {title && (
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: 'text.primary',
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        )}

        {children}
      </Container>

      {/* <Box sx={{ position: 'fixed', bottom: 20, right: 20, zIndex: 999 }}>
        <ChatButton size={50} />
      </Box> */}
    </Box>
  );
};

export default AuthLayout;
